import React from 'react';
import HomieContext from 'HomieContext';
import PartialReport from './PartialReport';
import FullReport from './FullReport';

type PropsType = {
  homeApplicationId: string,
  history: any
};
type StateType = {};

class ReportView extends React.Component<PropsType, StateType> {
  render() {
    const {
      currentUser,
      showLoadingProcessView,
      hideLoadingProcessView
    } = this.context;

    const { homeApplicationId, history } = this.props;

    const hiddenContent = currentUser.authenticated ? (
      <FullReport
        applicationId={homeApplicationId}
        userId={currentUser.id}
        history={history}
        showLoadingProcess={showLoadingProcessView}
        hideLoadingProcess={hideLoadingProcessView}
      />
    ) : (
      undefined
    );
    return (
      <PartialReport
        applicationId={homeApplicationId}
        showLoadingProcess={showLoadingProcessView}
        hideLoadingProcess={hideLoadingProcessView}
        hiddenContent={hiddenContent}
        isAuthenticated={currentUser.authenticated}
      />
    );
  }
}

ReportView.contextType = HomieContext;
export default ReportView;
